import { useSyncExternalStore } from 'react';
import { Moon, Sun } from 'lucide-react';

type Theme = 'light' | 'dark';
const key = 'relay-appearance';
const system = typeof window === 'undefined' ? null : window.matchMedia('(prefers-color-scheme: dark)');
const listeners = new Set<() => void>();
let preference: Theme | null = null;
try { const saved = localStorage.getItem(key); if (saved === 'light' || saved === 'dark') preference = saved; } catch { /* Storage may be unavailable in private sessions. */ }
let current: Theme = 'light';
function apply() {
  current = preference || (system?.matches ? 'dark' : 'light');
  if (typeof document !== 'undefined') document.documentElement.dataset.theme = current;
  listeners.forEach(listener => listener());
}
apply();
system?.addEventListener('change', () => { if (!preference) apply(); });
if (typeof window !== 'undefined') window.addEventListener('storage', event => {
  if (event.key !== key && event.key !== null) return;
  preference = event.newValue === 'light' || event.newValue === 'dark' ? event.newValue : null;
  apply();
});
const subscribe = (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; };

export default function ThemeToggle() {
  const theme = useSyncExternalStore(subscribe, () => current, () => 'light' as Theme);
  const label = theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';
  return <button className="icon-button theme-toggle" aria-label={label} title={label} aria-pressed={theme === 'dark'} onClick={() => {
    preference = theme === 'dark' ? 'light' : 'dark';
    try { localStorage.setItem(key, preference); } catch { /* Keep the choice for this visit. */ }
    apply();
  }}>{theme === 'dark' ? <Sun size={19}/> : <Moon size={19}/>}</button>;
}
